

























import Vue from 'vue';
import { ZenEllipsis } from 'zenComponents';

export default Vue.extend({
  name: 'AttachmentsCellPresenter',
  components: {
    ZenEllipsis,
  },
  computed: {
    attachments() {
      if (!this.$attrs.data) return [];
      return this.$attrs.data.value.edges;
    },
  },
});
